import { render, staticRenderFns } from "./PromotionInfo.html?vue&type=template&id=3f63389f&scoped=true&"
import script from "./PromotionInfo.js?vue&type=script&lang=js&"
export * from "./PromotionInfo.js?vue&type=script&lang=js&"
import style0 from "./PromotionInfo.scss?vue&type=style&index=0&id=3f63389f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63389f",
  null
  
)

export default component.exports